import React from "react";
import MenuContextProvider from "@/context/menu-context";
import SearchContextProvider from "@/context/search-context";
import Layout from "@/components/layout";
import Menu from "@/components/header-one";
import Footer from "@/components/footer";
import ContentEnsinoFundamental from "@/components/ContentEnsinoFundamental";
import SEO from '../components/seo'

const EnsinoFundamental = () => {
  return (
    <MenuContextProvider>
      <SearchContextProvider>
        <Layout>
          <SEO
            title="Educação Infantil - Foco em desenvolvimento integral e identidade árabe"
            pathname="/"
          />
          <Menu />
          <ContentEnsinoFundamental />
          <Footer /> 
        </Layout>
      </SearchContextProvider>
    </MenuContextProvider>
  )
}

export default EnsinoFundamental;
